import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import '../styles/Orders.css';

function Orders() {
  const products = [
    {
      name: 'Wireless Controller V2',
      price: '$100',
      stock: '7 in stock',
      image: '/wireless-controller-V2.jpg',
      description: 'The Wireless Controller is the latest version of our LoDis Signals Controller. It consumes 30% less power, is 25% smaller, and features configurable output states when compared to the Signal Controller V1.',
      features: [
        'Power Input: 9-24V DC',
        'Battery Life on 4Ah Ryobi Tool Battery: 16 Hours',
        'Range: 1/2 Mile in Dense Forest with Built in Antenna, Over 2 Miles with Antenna Upgrade Kit',
        '4 Inputs: 1 for Claim, 1 for Release, and 2 Additional for Route Selection, Turnout Control, or a Custom Feature for your Track!',
        '3 Outputs: Can be used to Control a Turnout, 3 Lamps on Any Signal, or a Custom Feature for your Track',
        '3kV Isolation to resist all severe weather conditions, inluding lightning',
        'Firmware Support for All New Features - Including Fully Automatic and Wireless Signal Control!'
      ]
    },
    {
      name: 'Signal Hub V1',
      price: '$30',
      stock: '2 in stock',
      image: '/Image-Coming-Soon.png',
      description: 'Upgrade your blocks with a Signal Hub! This allows you to monitor and control your system remotely and view the live status anywhere in the world over your Wi-Fi Network. One board is needed per block.',
      features: [
        'Power Input: USB-C',
        'Includes setting up a website to monitor your system remotely! (see https://neols-lodis.web.app/)',
        'Range: 1/2 Mile in Dense Forest with Built in Antenna, Over 2 Miles with Antenna Upgrade Kit',
        'Wi-Fi Connection to Your Live Status Website',
        'Firmware Support for All New Features - Including Fully Automatic and Wireless Signal Control!'
      ]
    }
  ];

  return (
    <div className="orders-page">
      <Navigation />
      <section className="esp32-section">
        <div className="esp32-container">
          <h1>Place Your Order</h1>
          <p className="esp32-intro">
            Below you will find a list of our available LoDis Wireless Signals products. 
            Each product is designed for reliable, long-distance, low-power wireless communication for your backyard railroad.
          </p>

          <div className="esp32-form">
            <h2>Available Products</h2>
            <div className="products-grid">
              {products.map((product, idx) => (
                <div key={idx} className="product-card">
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-info">
                    <h3>{product.name}</h3>
                    <p className="product-price">{product.price}</p>
                    <p className="product-stock-remaining">{product.stock}</p>
                    <p className="product-description">{product.description}</p>
                    <strong>Features:</strong>
                    <ul className="product-features">
                      {product.features.map((feature, fidx) => (
                        <li key={fidx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <h2 id="getting-started">Getting Started with LoDis Signals</h2>
            <p>
              To get started with LoDis Signals, you'll need two signals. Each Signal requires:
              <ul>
                <li>1 Wireless Controller V2</li>
                <li>1 Signal Head (Can be Customer or LoDis Provided)</li>
                <li>1 Battery</li>
                <li>1 Battery Adapter ($7-8 on Amazon)</li>
                <li>1 Plastic IP67 Enclosure with Cable Gromets ($15-20 on Amazon)</li>
                <li>2 IP67 Buttons (Can be Customer or LoDis Provide - $20 Each From LoDis)</li>
                <li>2 Conductor Sprinkler Cable for Connecting Buttons to Enclosures</li>
              </ul>
              If you would like to monitor your blocks remotely, you will also need one Signal Hub per block.
              <br/>
              For those interested in ready-to-run signals, we can pre-assemble and test your signals for you. 
              This includes all necessary wiring, enclosures, buttons, and battery adapters. 
              Please contact Caleb for more information and a quote as cost varies by Signal Head and how much cable you need.
            </p>

            <h2>How to Order</h2>
            <p>
              To place an order for LoDis Signals products, please contact Caleb at <a href="mailto:cjpalagyi@gmail.com">cjpalagyi@gmail.com</a> with details about your specific needs.
            </p>

            <p>
              For inquiries, firmware updates, or technical support, please refer to our <a href="/signals-firmware">Firmware</a> page or reach out to Caleb.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Orders;
